// eslint-disable-next-line max-len
const emailExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const numExp = /^\d+$/

/**
 * Simple validation helper.
 * If not enough this class functions, try library https://github.com/imbrn/v8n
 * Be free to add new checkers.
 */
export default class<T = unknown> {
  errors: string[] = []
  value?: T
  skipOnError = false

  constructor(value: T) {
    this.value = value
  }

  required(errorMessage: string, skipNextOnError = true): this {
    if (!this.value) {
      // При this.skipOnError равном true, и наличии ошибок валидации, следующие методы валидации не будут выполняться.
      this.skipOnError = skipNextOnError
      this.errors.push(errorMessage)
    }
    return this
  }

  requiredIf(parameter: boolean, errorMessage: string, skipNextOnError = true): this {
    if (parameter && !this.value) {
      // При this.skipOnError равном true, и наличии ошибок валидации, следующие методы валидации не будут выполняться.
      this.skipOnError = skipNextOnError
      this.errors.push(errorMessage)
    }
    return this
  }

  isEmail(errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if (!this.value || !emailExp.test((<string>this.value).toLowerCase())) {
      this.errors.push(errorMessage)
    }
    return this
  }

  isNumeric(errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if (!numExp.test(<string>this.value)) {
      this.errors.push(errorMessage)
    }
    return this
  }

  lengths(lengths: number[], errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if ((Array.isArray(this.value) || typeof this.value === 'string') && !lengths.includes(this.value?.length)) {
      this.errors.push(errorMessage)
    }
    return this
  }

  date(errorMessage: string): this {
    if (this.skip() || !this.value) {
      return this
    }
    if (!/^\d{1,2}.\d{1,2}.\d{4}$/.test(<string>this.value)) {
      this.errors.push(errorMessage)
      return this
    }
    try {
      const dateParts = (<string>this.value).split('.')
      // 23 - это конец дня, чтобы при приведении к iso не сбивалась дата
      const date = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]), 23)
      // toISOString выбрасывает ошибку, если дата в неправильном формате
      date.toISOString()
    } catch (e) {
      this.errors.push(errorMessage)
    }
    return this
  }

  inEnum(list: object, errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if (this.value && !Object.values(list).includes(this.value)) {
      this.errors.push(errorMessage)
    }
    return this
  }

  callback(callback: (value?: T) => boolean, errorMessage: string): this {
    if (!callback(this.value)) {
      this.errors.push(errorMessage)
    }
    return this
  }

  skip(): boolean {
    return this.skipOnError && this.hasError()
  }

  hasError(): boolean {
    return this.errors.length !== 0
  }

  firstError(): string {
    if (this.hasError()) {
      return this.errors[0]
    }
    return ''
  }

  allErrors(): string[] {
    return this.errors
  }

  allErrorsToString(): string {
    return this.errors.join('\n')
  }
}
